import { render, staticRenderFns } from "./AddTel.vue?vue&type=template&id=771bf932&scoped=true&"
import script from "./AddTel.vue?vue&type=script&lang=js&"
export * from "./AddTel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771bf932",
  null
  
)

export default component.exports